<template>
	<div class="register-container">
		<img class="popularBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="register-content">
			<div class="title">
				请选择您喜欢的标签，平台推荐更精准哦!
			</div>
			<div class="contentBox">
				<div class="cateBox">
					<div class="cateBoxTitle">
						图片分类
					</div>
					<div class="cateList">
						<div class="cateItem" :class="{'active': cate.findIndex(row => row == item.id) > -1}"
							v-for="(item,index) in typeOpts" :key="index" @click="addCate(item)">
							{{item.title}}
						</div>
					</div>
				</div>
				<div class="cateBox">
					<div class="cateBoxTitle">
						图片用途
					</div>
					<div class="cateList">
						<div class="cateItem" :class="{'active': purpose.findIndex(row => row == item.id)>-1}"
							v-for="(item,index) in yongtuOpts" :key="index" @click="addPurpose(item)">
							{{item.title}}
						</div>
					</div>
				</div>
			</div>
			<div class="confirm" @click="submitConfirm">确认</div>
		</div>
		<div class="copyright">
			Copyright © 2025 岱屿画境 浙ICP备2025195505号 <img class="police" src="../assets/Register/police.png"
				alt="" />浙公网安备33010202005149号
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PersonalLike',
		data() {
			return {
				cate: [],
				purpose: [],
				typeOpts: [],
				yongtuOpts: [],
			}
		},
		created() {
			this.basicsLabelList()
			this.basicsClassifyList()
		},
		methods: {
			basicsLabelList() {
				this.$api.post('/Other/classify_list', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						this.typeOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsClassifyList() {
				this.$api.post('/Other/classify_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.yongtuOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			addCate(item) {
				const index = this.cate.findIndex((row => row == item.id))
				if (index > -1) {
					this.cate.splice(index, 1)
				} else {
					this.cate.push(item.id)
				}
			},
			addPurpose(item) {
				const index = this.purpose.findIndex((row => row == item.id))
				if (index > -1) {
					this.purpose.splice(index, 1)
				} else {
					this.purpose.push(item.id)
				}
			},
			submitConfirm() {
				if (this.cate.length == 0 || this.purpose.length == 0) return this.$message.warning('请设置您喜欢的图片分类和用途！')
				this.$api.post('/UserD/user_save', {
					image_fl: this.cate.join(','),
					image_yt: this.purpose.join(',')
				}).then(res => {
					if (res.code == 1) {
						this.$message.success('设置成功！')
						this.$router.push('/')
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.register-container {
		width: 100%;
		height: 100vh;
		background: #FAEFDD;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		.popularBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.register-content {
		margin-left: .1rem;
		margin-right: .1rem;
		display: flex;
		flex-direction: column;
		width: 10.48rem;
		max-height: 7.82rem;
		background: #FFFFFF;
		border-radius: .12rem;
		overflow: hidden;
		z-index: 1;

		.title {
			width: 100%;
			height: .82rem;
			padding-left: .6rem;
			font-weight: 500;
			font-size: .24rem;
			color: #4C4943;
			line-height: .82rem;
			background: #CDBB98;
		}

		.contentBox {
			display: flex;
			flex-direction: column;
			padding: 0 0 0 .6rem;

			.cateBox {
				display: flex;
				flex-direction: column;
				margin-top: .38rem;

				.cateBoxTitle {
					font-weight: 600;
					font-size: .16rem;
					color: #333333;
					line-height: .22rem;
				}

				.cateList {
					display: flex;
					flex-wrap: wrap;

					.cateItem {
						margin-top: .24rem;
						margin-right: .32rem;
						width: 1.28rem;
						height: .48rem;
						font-weight: 400;
						font-size: .16rem;
						color: #666666;
						border-radius: .04rem;
						border: .01rem solid #CCCCCC;
						line-height: .48rem;
						text-align: center;
						cursor: pointer;

						&:hover {
							color: #E29358;
							border-color: #E29358;
						}

						&.active {
							color: #E29358;
							border-color: #E29358;
						}
					}
				}
			}
		}

		.confirm {
			margin: .54rem auto .48rem;
			width: 1.76rem;
			height: .5rem;
			background: #E29358;
			border-radius: .04rem;
			font-weight: 400;
			font-size: .16rem;
			text-align: center;
			line-height: .5rem;
			color: #252525;
			cursor: pointer;
		}
	}

	.copyright {
		position: fixed;
		bottom: .16rem;
		// left: 50%;
		// transform: translateX(-50%);
		font-weight: 400;
		font-size: .12rem;
		color: #333333;
		display: flex;
		align-items: center;

		.police {
			margin-left: .12rem;
			margin-right: .04rem;
			width: .14rem;
			height: .14rem;
		}
	}
</style>